var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"opacity":".8","value":_vm.loadingShow}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}}),_c('v-card-title',[_vm._v(_vm._s(_vm.loadingTitle))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }